export const UPDATE_ORG = 'UPDATE_ORG';
export const REMOVE_ORG = 'REMOVE_ORG';
export const CHANGE_SELECTED_ORG = 'CHANGE_SELECTED_ORG';
